import * as React from "react";
import styled from "styled-components";
import DOMPurify from "isomorphic-dompurify";
const INLINE_TAGS = [
    "b",
    "strong",
    "em",
    "i",
    "a",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "u",
    "sup",
    "sub",
    "del",
    "br",
    "p",
];
const FULL_BODY = INLINE_TAGS.concat([
    "img",
    "header",
    "table",
    "td",
    "tr",
    "th",
    "ul",
    "ol",
    "li",
    "blockquote",
    "span",
    "figure",
    "figcaption",
]);
export const TAG_SETS = {
    INLINE_TAGS,
    FULL_BODY,
};
const StylableRichTextHTML = ({ rawHTML, allowedTags, ...htmlProps }) => {
    const config = {
        KEEP_CONTENT: true,
        ADD_ATTR: ["target"],
    };
    if (allowedTags) {
        config.ALLOWED_TAGS = allowedTags;
    }
    const clean = DOMPurify.sanitize(rawHTML, config);
    return (React.createElement("div", { ...htmlProps },
        React.createElement("div", { dangerouslySetInnerHTML: { __html: clean } })));
};
StylableRichTextHTML.defaultProps = {
    "data-testid": "rich-text-html",
};
export const RichTextHTML = styled(StylableRichTextHTML) ``;
//# sourceMappingURL=RichTextHTML.js.map